// @flow

import * as React from "react";

import LinkHandler from "./LinkHandler";
import { type LinkType } from "../../types";

type PropsType = {
    className: string,
    children: React.Node,
    to?: string,
    link?: LinkType,
    customButton?: boolean,
    styles?: [],
};

const TextButton = (props: PropsType): React.Node => {
    const {
        link,
        styles,
        children,
        className,
        customButton,
        ...remainingProps
    } = props;

    const isAnchor = props.to || (link && link.url);
    const RootElement = isAnchor ? LinkHandler : "button";
    const classes = ["text-button"];
    const innerClasses = ["text-button__text"];

    if (className) {
        classes.push(className);
    }

    if (customButton) {
        innerClasses.push("text-button__text--custom-button");
    }

    let autoProps = { ...remainingProps };
    if (link) {
        autoProps = {
            to: link.url,
            target: link.target,
        };
    }

    return (
        <RootElement {...autoProps} className={classes.join(" ")}>
            {link ? (
                link.title
            ) : typeof children === "string" ? (
                <span
                    className={innerClasses.join(" ")}
                    dangerouslySetInnerHTML={{ __html: children }}
                ></span>
            ) : (
                <span className={innerClasses.join(" ")}>{children}</span>
            )}
        </RootElement>
    );
};

TextButton.defaultProps = {
    className: "",
    children: null,
};

export default TextButton;
